import { medtechApiClient } from './index';
import { MedtechUserV3 } from '../types/users';

export const usersApi = {
  async fetchUsers(companyId: number): Promise<MedtechUserV3[]> {
    return (
      await medtechApiClient.get<MedtechUserV3[]>(`/v3/${companyId}/users?usergroup=quality&invite_status=accepted`)
    ).data;
  },
};
